import {ViewDocumentPanel} from "document/component/container";

const ViewConcelloDocumentPanel = () => {
    return <ViewDocumentPanel />;
};

export default ViewConcelloDocumentPanel;
